<template>
  <GfrNewButton class="app-download-trigger" :class="['app-download-trigger-' + size]" @click="triggerDownload">
    <slot />
    <IconsDownload class="app-download-icon" />
  </GfrNewButton>
</template>
<script lang="ts" setup>
const triggerDownload = inject('triggerDownload') as (triggerDownload: () => void) => {}
defineProps({
  size: {
    type: String as PropType<'normal' | 'large'>,
    default: 'normal'
  }
})
</script>
<style lang="scss" scoped>
.app-download-trigger {
  @apply h-8 rounded-[2px] bg-primary-color px-4 text-sm font-bold leading-[22px] text-dark-foreground transition-colors duration-200 hover:bg-primary-hover;
  @apply max-lg:text-xs max-lg:leading-4.5;
}
.app-download-icon {
  @apply -mt-px h-3.5 w-3.5 ltr:ml-1 rtl:mr-1;
}
.app-download-trigger-large {
  @apply h-10 min-w-45;
  @apply max-lg:h-7 max-lg:min-w-37;
}
</style>
